import AttributeRulesTab from './AttributeRulesTab';
export default AttributeRulesTab;
